import * as ENUM_LABELS from "../labels/enum";

export const LABELS: Record<string, string> = {
    [ENUM_LABELS.CONVENIENCE_STORE_SEVEN_ELEVEN]: "세븐일레븐",
    [ENUM_LABELS.CONVENIENCE_STORE_FAMILY_MART]: "Family Mart",
    [ENUM_LABELS.CONVENIENCE_STORE_LAWSON]: "Lawson",
    [ENUM_LABELS.CONVENIENCE_STORE_MINI_STOP]: "MINI STOP",
    [ENUM_LABELS.CONVENIENCE_STORE_SEICO_MART]: "SEICO Mart",
    [ENUM_LABELS.CONVENIENCE_STORE_DAILY_YAMAZAKI]: "Daiy Yamazaki",
    [ENUM_LABELS.CONVENIENCE_STORE_PAY_EASY]: "Pay Easy",
    [ENUM_LABELS.CONVENIENCE_STORE_YAMAZAKI_DAILY_STORE]: "Yamazaki Daily",

    [ENUM_LABELS.CARD_VISA]: "Visa",
    [ENUM_LABELS.CARD_AMEX]: "American Express",
    [ENUM_LABELS.CARD_MASTERCARD]: "Mastercard",
    [ENUM_LABELS.CARD_MAESTRO]: "Maestro",
    [ENUM_LABELS.CARD_DISCOVER]: "Discover",
    [ENUM_LABELS.CARD_JCB]: "JCB",
    [ENUM_LABELS.CARD_DINERS]: "Diners Club",
    [ENUM_LABELS.CARD_UNIONPAY]: "UnionPay",
};

export default LABELS;
